import React from "react"
import { Button, Modal } from "react-bootstrap"

export default class ButtonCancelSale extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false
        }
        this._openModalCancelSale = this._openModalCancelSale.bind(this)
        this._closeModalCancelSale = this._closeModalCancelSale.bind(this)
        this._cancelSale = this._cancelSale.bind(this)
    }
    _openModalCancelSale() {
        this.setState({ ...this, show: true })
    }
    _closeModalCancelSale() {
        this.setState({ ...this, show: false })
    }
    _cancelSale() {
        window.localStorage.removeItem("sale")
        window.location.href = "/pos"
    }
    render() {
        return <div className={this.props.className}>
            <Button onClick={this._openModalCancelSale} className="w-100 dim py-2" variant="danger">
                Cancelar venda
            </Button>
            <Modal show={this.state.show} onHide={this._closeModalCancelSale}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Cancelar venda
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="lead text-center">
                        A venda atual será  cancelada
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this._cancelSale}>
                        Sim, cancelar a venda
                    </Button>
                    <Button onClick={this._closeModalCancelSale}>
                        Não, continuar a venda
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/components/FooterActionsPOS/CancelSale/index.jsx